import { render, staticRenderFns } from "./Auto_project.vue?vue&type=template&id=28a5d8d8&scoped=true"
import script from "./Auto_project.vue?vue&type=script&lang=js"
export * from "./Auto_project.vue?vue&type=script&lang=js"
import style0 from "./Auto_project.vue?vue&type=style&index=0&id=28a5d8d8&prod&lang=css"
import style1 from "./Auto_project.vue?vue&type=style&index=1&id=28a5d8d8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5d8d8",
  null
  
)

export default component.exports